import './common'
import axios from 'axios'

export default {
    // Setups
    syncAllStats: (params) => axios.get('/stats/sync-all-stats', { params }),
    deleteAllStats: (params) => axios.get('/stats/delete-all-stats', { params }),
    resetAllStats: (params) => axios.get('/stats/reset-all-stats', { params }),
    refreshAllStats: (params) => axios.get('/stats/refresh-all-stats', { params }),

    getSyncAllStatsTimetables: (params) => axios.get('/stats/setup/sync-timetables-import', { params }),
    getNewSyncAllStatsTimetables: (params) => axios.get('/stats/setup/sync-timetables-refresh', { params }),
    getSyncAllStatsTimetablesFormatted: (params) => axios.get('/stats/setup/sync-timetables-formatted', { params }),

    // Predictions
    getPredictionsPassings: (params) => axios.get('/stats/predictions/passings', { params }),

    // Dashboard
    getStatsDashboardLayouts: (params) => axios.get('/stats/dashboard/layout', { params }),
    upsertStatsDashboardLayout: (data, params) => axios.post('/stats/dashboard/layout', data, { params }),

    // Utils
    getStatsResaYearsWithData: (params) => axios.get('/stats-resa/years-with-data', { params }),
    getStatsResaFirstYearWithData: (params) => axios.get('/stats-resa/years-with-data/first', { params }),
    getStatsResaLastYearWithData: (params) => axios.get('/stats-resa/years-with-data/last', { params }),

    // Passings
    getStatsPassingsFrequentations: (params) => axios.get('/stats/passings/frequentations', { params }),
    getStatsPassingsPlannings: (params) => axios.get('/stats/passings/plannings', { params }),

    getStatsPassingsByProductTypeExcelGlobal: (params) => axios.get('/stats/passings/excel/global/by-product-type', { params, responseType: 'blob' }),
    getStatsPassingsByProductExcelGlobal: (params) => axios.get('/stats/passings/excel/global/by-product', { params, responseType: 'blob' }),
    getStatsPassingsByActivityExcelGlobal: (params) => axios.get('/stats/passings/excel/global/by-activity', { params, responseType: 'blob' }),
    postStatsPassingsExcelClientsDataTable: (data) => axios.post('/stats/passings/excel/clients-data-table', data, { responseType: 'blob' }),

    // Sales
    getStatsSalesPeriodicReport: (params) => axios.get('/stats/sales/periodic-report', { params }),

    // Spa
    getSoldProductsPeriodicReport: (params) => axios.get('/stats/spa/periodic-report', { params }),
    getStatsSpaResourcesOccupationRates: (params) => axios.get('/stats/spa/occupation-rates/resources', { params }),
    getStatsSpaPersonnelsOccupationRates: (params) => axios.get('/stats/spa/occupation-rates/personnels', { params }),
    getStatsSpaExcel: (params) => axios.get('/stats/spa/export', { params, responseType: 'blob' }),

    /// RESA
    // Descriptives : Totaux

    /// ///////////////////////////////////////      Pre-select Filters     ///////////////////////////////////////////////////////

    // All resa
    selectSavedFiltersResaNames: (params) => axios.get('/stats-resa/saved-filters/resa/select/names', { params }),
    selectSavedFiltersResa: (params) => axios.get('/stats-resa/saved-filters/resa/select', { params }),
    insertSavedFilterResa: (data) => axios.post('/stats-resa/saved-filters/resa/insert', data),
    updateSavedFilterResa: (data) => axios.post('/stats-resa/saved-filters/resa/update', data),
    deleteSavedFilterResa: (params) => axios.get('/stats-resa/saved-filters/resa/delete', { params }),

    /// ///////////////////////////////////////      Fréquentations     ///////////////////////////////////////////////////////

    getStatsResaFrequentationsParActivite: (params) => axios.get('/stats-resa/frequentations/par-activite', { params }),

    /// ///////////////////////////////////////      Bilans Périodiques     ///////////////////////////////////////////////////////
    // Réservations
    getStatsResaDescriptivesProportionsTypesResa: (params) => axios.get('/stats-resa/bilans-periodiques/reservations/proportions-types-resa', { params }),

    // Activités
    getStatsResaDescriptivesActivitiesData: (params) => axios.get('/stats-resa/bilans-periodiques/activites/activities-data', { params }),

    // Clients
    getStatsResaDescriptivesClientsAge: (params) => axios.get('/stats-resa/bilans-periodiques/clients/activities-by-age', { params }),

    // Articles

    // Bookings Slots
    getBookingsSlotsDetailled: (params) => axios.get('/stats-resa/bilans-periodiques/bookings-slots/detailled', { params }),
    getBookingsSlotsCount: (params) => axios.get('/stats-resa/bilans-periodiques/bookings-slots/count', { params }),

    // Trainers
    getTrainersDetailled: (params) => axios.get('/stats-resa/bilans-periodiques/trainers/detailled', { params }),

    /// ///////////////////////////////////////      Plannings     ///////////////////////////////////////////////////////

    // Plannings CR
    getStatsResaPlanningsCRByDateRange: (params) => axios.get('/stats-resa/plannings/cr/by-date-range', { params })

}
